import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { ICameraInfo, ILiveStreamInfo, ILiveStreamSettings, ILiveStreamStats, RootState } from 'AppTypes'
import { api } from '@services'
import { AxiosResponse } from 'axios'

export const initialState = {
  originalSettings: {} as ILiveStreamSettings,
  liveStreamSettings: {} as ILiveStreamSettings,
  cameras: [] as ICameraInfo[],
  pageIndex: 1,
  pageSize: 500
}

// export const fetchAr
export const fetchLiveStreamSettings = createAsyncThunk(
  'live/fetchLiveStreamSettings',
  async (_, thunkApi) => {
    const storeId = (thunkApi.getState() as RootState).storeUser.storeUser.storeIds?.[0]
    if (storeId === undefined) {
      throw new Error('Store information is missing')
    }
    const response = await api.liveStream.fetchLiveStreamSettings(storeId)
    return response.data.data
  }
)

export const fetchCameraList = createAsyncThunk(
  'live/fetchCameraList',
  async (params: any, thunkApi) => {
    const storeId = (thunkApi.getState() as RootState).storeUser.storeUser.storeIds?.[0]
    if (storeId === undefined) {
      throw new Error('Store information is missing')
    }
    params.storeId = storeId
    const response = await api.liveStream.fetchCameraList(params)
    return response.data.data
  }
)

export const updateLiveStreamSettings = createAsyncThunk(
  'live/updateLiveStreamSettings',
  async (_, thunkApi) => {
    const state = thunkApi.getState() as RootState
    const response = await api.liveStream.updateLiveStreamSettings(state.liveStream.liveStreamSettings)
    return response
  }
)

export const changeCameraStatus = createAsyncThunk(
  'live/changeCameraStatus',
  async params => {
    const response = await api.liveStream.changeCameraStatus(params)
    return response
  }
)

const liveStreamSlice = createSlice({
  name: 'live',
  initialState,
  reducers: {
    publicSettingChange: (state, action: PayloadAction<boolean>) => {
      state.liveStreamSettings.isPublish = action.payload
    },
    timeToPlayChange: (state, action: PayloadAction<string>) => {
      state.liveStreamSettings.timeToPlay = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchLiveStreamSettings.fulfilled, (state, action) => {
      state.originalSettings = action.payload
      state.liveStreamSettings = { ...action.payload }
    })
    builder.addCase(fetchCameraList.fulfilled, (state, action) => {
      state.cameras = action.payload
    })
    builder.addCase(updateLiveStreamSettings.fulfilled, (state, action) => {
      state.originalSettings = { ...state.liveStreamSettings }
    })
    builder.addCase(updateLiveStreamSettings.rejected, state => {
      state.liveStreamSettings = { ...state.originalSettings }
    })
    builder.addCase(changeCameraStatus.fulfilled, (state, action) => {

    })
  }
})

export const {
  publicSettingChange,
  timeToPlayChange
} = liveStreamSlice.actions

export default liveStreamSlice.reducer
